import { JobReady } from "@domain/CRM/job";
import { DataAPI_Base } from "../base";

export class JobsReadyAPI extends DataAPI_Base<JobReady> {
	constructor() {
		super("jobsready", JobReady);
	}
}
